import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Form, Formik } from "formik";
import { postQuoteNotes} from "redux/actions/admin";
import styled from "styled-components";
import TextArea from 'web/components/form-elements/TextArea';
import AlertModal from "web/components/AlertModal";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { storeAdminDetails, logoutAdmin } from "redux/actions/admin";
import {
  getQuoteNotesInitialValues,
  VALIDATION_SCHEMA,
} from "web/components/utils/notesQuoteModalUtils";

const NotesModal = ({
  toggle,
  editResponse,
  editFlag,
}) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState("");

  const [alertType, setAlertType] = useState();

  useEffect(() => {
  }, []);

  const addComment = async (props) => {
    let data={
      id:editResponse?.quoteId,
      notes: props.values?.notes,
    }
    const token = localStorage.getItem("token");
    let response = await dispatch(postQuoteNotes(data, token));
    if (response.status === "SUCCESS") {
      setAlertModalContent(response?.message);
      setAlertModal(!alertModal);
      setAlertType("success");
    } else {
      if (response?.statusCode === 401) {
        adminLogout();
      } else {
        setAlertModalContent(response?.message);
        setAlertModal(true);
      }
    }
  };

  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}));
    dispatch(logoutAdmin());
    localStorage.removeItem("adminRolesData");
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("token");
    history.push("./sign-in");
    window.location.reload(false);
  };

  return (
    <>
      <div>
        <div className="modal-header-style">
          <h6>Admin Notes</h6>
          <img
            src={CloseIcon}
            alt="close-icon"
            onClick={() => {
              toggle();
            }}
          />
        </div>

        <Formik
          initialValues={getQuoteNotesInitialValues(editResponse, editFlag)}
          validationSchema={VALIDATION_SCHEMA()}
          onSubmit={(values) => {}}
        >
          {(props) => {
            const { isValid, dirty } = props;

            return (
              <Form>
                <div
                  style={{ padding: "25px 25px 0px", "padding-bottom": "0px" }}
                >
                  <InputFieldsWrapper>
                      <div className="row">
                        <div className="col-md-12 mb-4">
                          <TextArea
                              name='notes'
                              maxLength='200'
                              showErrorMessages={true}
                              value={editResponse.notes}
                          />
                        </div>
                      </div>
                  </InputFieldsWrapper>
                </div>

                <InputFieldsWrapper>
                  <div
                    className="submitBtn"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      "margin-bottom": "20px",
                    }}
                  >
                    <button
                      className="green-button"                     
                      onClick={() => {
                        toggle();
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className="green-button"
                      disabled={!(isValid && dirty)}
                      onClick={() => {
                        if (editFlag) {
                        } else {
                          addComment(props);
                        }
                      }}
                    >
                      {editFlag ? "Update" : "Submit"}
                    </button>
                  </div>
                </InputFieldsWrapper>
              </Form>
            );
          }}
        </Formik>
      </div>
      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType={alertType}
        callBackAlert={(val) => {
          if (val === "success") {
            toggle();
          }
        }}
      />
    </>
  );
}

export default NotesModal;

const InputFieldsWrapper = styled.div`
  .css-os3nnz-control {
    border: none;
  }
  .app-input-text {
    font-size: 15px;
  }
  .css-1lmoifu-control {
    background-color: #fff !important;
    border-color: #fff !important;
    border-bottom: 1px solid rgb(225, 225, 225) !important;
  }
  p {
    color: #ef5657;
    font-size: 11px;
    margin-top: 2px;
  }
  img {
    top: 4px !important;
    left: 6px !important;
    width: 20px;
    height: 20px;
  }
  input {
    border: none;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 0;
    padding: 0;
    border-top: none;
    border-right: none;
    border-left: none;
    border-image: initial;
    border-bottom: 1px solid rgb(225, 225, 225) !important;
    border-radius: 0px;
    padding: 0px;
  }
  .fixed-height {
    position: relative;
    min-height: 72px;
    .height-adjust {
      position: absolute;
      top: 15px;
      width: 90%;
    }
  }
  .green-button {
    background: linear-gradient(90deg, #55c416 1.12%, #367910 100%);
    border: none;
    border-radius: 5px;
    height: 30px;
    color: #fff;
    font-size: 14px;
    margin-right: 15px;
  }
  .bordered-input {
    input {
      border: 1px solid #87cdf1;
      border-radius: 5px;
      padding: 0px 10px 0px 10px;
    }
  }
  .error-styling-input {
    input {
      border: none !important;
      border-bottom: 1px solid #ef5657 !important;
    }
  }
  .app-input-text {
    margin-bottom: 15px !important;
  }
  .app-input-text input.error {
    border: none !important;
    border-bottom: 1px solid #ef5657 !important;
  }
  .submitBtn button:disabled {
    background: linear-gradient(90deg, #979797 1.12%, #979797 100%) !important;
    color: -internal-light-dark(
      rgba(16, 16, 16, 0.3),
      rgba(255, 255, 255, 0.3)
    ) !important;
    border-color: -internal-light-dark(
      rgba(118, 118, 118, 0.3),
      rgba(195, 195, 195, 0.3)
    ) !important;
  }
  input:disabled {
    opacity: 0.5;
  }
`;
